import React, { useEffect, useRef, useState, Fragment } from "react";

import { useField } from "@rocketseat/unform";

import MaskedInput from "react-text-mask";

export default function MaskedField({ name, mask, customfunction, ...props }) {
  const { fieldName, registerField, defaultValue, error } = useField(name);
  const ref = useRef();
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: ref.current,
      path: "props.value", // eslint-disable-line
      clearValue: pickerRef => {
        console.log(pickerRef);
      }
    });
    // eslint-disable-next-line prettier/prettier
  }, [ref.current, fieldName]); // eslint-disable-line

  function handleChange(event) {
    const value = event.target.value;

    if (customfunction) {
      customfunction(event);
    }

    setValue(value);
  }

  return (
    <Fragment>
      <MaskedInput
        name={fieldName}
        ref={ref}
        mask={mask}
        value={value}
        showMask={false}
        guide={false}
        onChange={handleChange}
        {...props}
      />
      {error ? <span>{error}</span> : null}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/MaskedField/index.js